<template>
  <!-- TODO сделать лоадер -->
  <div v-if="!isFetched">Идёт загрузка...</div>
  <div v-else>
    <!-- TODO сделать константу -->
    <div class="font-bold montserat report-title">{{ reportName }}</div>
    <div v-for="block of renderParams.config.blocks" :key="block.key">
      <PlatformsTable
        v-if="platformsReport.length && block.key === 'platform-feedback'"
        :platformsReport="platformsReport"
        :interestedPartyLength="interestedParty.length"
      />
      <InterestedParty
        v-if="block.key === 'interested-party'"
        :interestedParty="interestedParty"
      />
      <PartnersTable
        v-if="block.key === 'partners' && interestedParty.length"
        :interestedParty="interestedParty"
        :additionalParams="renderParams.config?.additionalParams || []"
      />
      <div
        v-if="toShowFields && block.key === 'fields'"
        :class="additionalFieldsClass"
      >
        <div :class="additionalFielsTitleClass">{{ additionalFielsTitle }}</div>
        <ul class="params d-flex flex-column">
          <li
            class="report-parameter"
            :class="reportRowClass"
            v-for="cf of optionFields"
            :key="cf.field_id"
          >
            <div :class="reportDescriptionClass" v-text="cf.field_name" />
            <div
              :class="reportDigitsClass"
              v-html="
                cf.values
                  .map((v) => prepareCfValue(v.value))
                  .filter(Boolean)
                  .join(', ')
              "
            />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import axios from 'axios'
import { ref } from 'vue'
import PlatformsTable from './PlatformsTable/PlatformsTable.vue'
import InterestedParty from './InterestedParty/InterestedParty.vue'
import PartnersTable from './PartnersTable/PartnersTable.vue'
import Common from './../../services/common.js'
import Locale from '../../services/locale'

export default {
  name: 'Report',
  components: {
    PlatformsTable,
    InterestedParty,
    PartnersTable,
  },
  props: {
    domain: String,
    leads: Array,
    renderParams: Object,
    localeService: Locale,
  },
  setup(props) {
    const platformsReport = ref([])
    const interestedParty = ref([])
    const isFetched = ref(false)

    const lead = props.leads[0]

    const fetchPlatformsReport = async () => {
      const lead = props.leads[0]
      const cfs = lead.custom_fields_values || []

      // api dev localhost:3004
      // api prod https://d1.winwinapp.ru

      // получаю конфиги ОС для этого аккаунта
      const feedbackConfig = await axios.get(
        `https://d1.winwinapp.ru/config/feedbacks/${props.domain}`,
      )
      const fbConfigs = feedbackConfig?.data?.configs || []

      // получаю конфиги фидов для этого аккаунта
      const uploadsConfig = await axios.get(
        `https://d1.winwinapp.ru/config/uploads/${props.domain}`,
      )
      const accountFeeds = uploadsConfig?.data?.feeds || []

      return accountFeeds
        .map((feed) => {
          // проверяю, активен ли фид
          // по коду поля переключателя фида ищу это поле в сделке
          // и смотрю на его значение (true или null)
          const isActiveFeed = cfs.find(
            (cf) => cf.field_id === feed.id || cf.field_code === feed.code,
          )?.values[0].value
          if (!isActiveFeed) {
            return
          }

          // если фид активен,
          // то ищу ids полей для ОС этого фида
          const suitableConfig = fbConfigs.find(
            (config) => config.feedId === feed._id,
          )
          if (!suitableConfig) {
            return
          }

          const fbFields = suitableConfig?.fields || {}
          const platformFields = fbFields[feed.type] || {}

          const fbFieldTypes = ['url', 'phoneShows', 'totalViews', 'status']
          fbFieldTypes.forEach((f) => {
            if (platformFields[f]) return
            platformFields[f] = null
          })

          // по ids полей для ОС ищу их значения в сделке
          // и формирую объект { код_поля_ОС: значение_поля  }
          let fields = {}
          Object.entries(platformFields).forEach(([fieldKey, fieldId]) => {
            fields = {
              ...fields,
              [fieldKey]:
                fieldId &&
                cfs.find((cf) => cf.field_id === Number(fieldId))?.values[0]
                  ?.value,
            }
          })
          if (feed.type === 'domclick') {
            fields.phoneShows = null
          }

          return {
            name: feed.name,
            type: feed.type,
            fields,
          }
        })
        .filter(Boolean)
    }
    const fetchInterestedParty = () => {
      const lead = props.leads[0]
      const { additionalParams } = props.renderParams.config
      const withParam = additionalParams.map((p) => p.key).join(',')
      const { host } = new URL(location.href)
      const dev = host.includes('dev-io') ? 'dev-' : ''
      return axios
        .get(
          `https://${dev}sele.winwinapp.ru/interested-party/${props.domain}/${lead?.id}`,
          { params: { with: withParam } },
        )
        .then((res) => {
          const interestLeads = res.data
          return interestLeads.map((i) => ({
            ...i,
            fields: i?.fields.map((f) => ({
              name: f.name?.split('#')[0].trim(),
              value: String(f.value)?.includes('#')
                ? f.value?.split('#')[1].trim()
                : f.value,
            })),
          }))
        })
        .catch(() => [])
    }

    const reportNameId = props.renderParams?.config.presentationNameFieldId
    const reportNameField = lead.custom_fields_values?.find(
      (cf) => cf.field_id === reportNameId,
    )

    return {
      platformsReport,
      interestedParty,
      isFetched,
      fetchPlatformsReport,
      fetchInterestedParty,
      reportName: reportNameField?.values[0].value || 'Отчёт по объекту',
    }
  },
  async mounted() {
    this.platformsReport = await this.fetchPlatformsReport().catch(() => [])
    this.interestedParty = await this.fetchInterestedParty()
    this.isFetched = true

    try {
      document.body.classList.add('report-view')
      const customScript = this.renderParams.config?.script
      if (!customScript) return
      $(document.body).append($(customScript))
    } catch (e) {
      console.error(e)
    }
  },
  computed: {
    toShowFields() {
      return this.optionFields?.length
    },
    isMobileVersion() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      )
    },
    additionalFielsTitleClass() {
      return {
        'additional-fiels-title': !this.isMobileVersion,
        'platform-block--mobile': this.isMobileVersion,
      }
    },
    additionalFielsTitle() {
      return this.isMobileVersion
        ? 'Дополнительные поля'
        : 'Дополнительные поля:'
    },
    reportRowClass() {
      return {
        'd-flex': !this.isMobileVersion,
        'report-row-mobile': this.isMobileVersion,
      }
    },
    reportDescriptionClass() {
      return {
        'report-description': true,
        'report-description-flex': !this.isMobileVersion,
      }
    },
    reportDigitsClass() {
      return {
        'report-digits': true,
        'report-digits-flex': !this.isMobileVersion,
      }
    },
    additionalFieldsClass() {
      return this.isMobileVersion
        ? 'additional-fiels-mobile'
        : 'additional-fiels'
    },
    options() {
      return this.renderParams.config?.options
    },
    optionFields() {
      const firstLead = this.leads[0]
      const cfs = firstLead?.custom_fields_values
      const price = {
        field_type: 'numeric',
        field_name: 'Комиссия',
        field_id: 1,
        values: [
          {
            value: firstLead?.price,
          },
        ],
      }

      return this.options
        .filter((o) => {
          if (o === 1) return Boolean(firstLead?.price)
          return cfs?.some((cf) => cf.field_id === o && cf.values[0].value)
        })
        .map((o) =>
          Common.getFormattedField({
            field: o === 1 ? price : cfs?.find((cf) => cf.field_id === o),
            dateFormat: this.renderParams.date,
            fieldsConfig: this.renderParams.hidingFieldsConfig,
            currencyDict: this.renderParams.currencyDict,
            priceFrom: this.renderParams.config.priceFrom,
            priceFieldId: this.renderParams.config.price,
            currencySymbol: this.renderParams.currency.symbol_native,
            localeService: this.localeService,
          }),
        )
    },
  },
  methods: {
    prepareCfValue(value) {
      if (!value) return ''
      if (!value.includes('#')) return value
      return String(value).replaceAll('!n', '').split('#')[1].trim()
    },
  },
}
</script>

<style>
.platform-block--mobile {
  font-size: 16px;
  font-weight: 500;
  font-family: Inter;
}

.poppins-weight400-13 {
  font-weight: 700;
  font-family: 'Montserrat', sans-serif;
  font-size: 13;
}

.report-title {
  color: #323c47;
  margin-bottom: 10px;
  font-size: 22px;
  text-align: center;
}

.report-parameter {
  margin-right: 0;
  width: 100%;
  overflow-wrap: break-word;
  padding-bottom: 16px;
  padding-right: 2%;
}
.report-description {
  line-height: 22px;
  font-size: 16px;
  font-family: Roboto;
  text-align: left;
  color: rgb(115, 122, 142);
}
.report-row-mobile {
  display: grid;
  grid-template-columns: 2fr 1fr;
}
.report-description-flex {
  flex-basis: 240px;
}
.report-digits {
  font-family: Roboto;
  line-height: 22px;
  font-size: 16px;
  font-weight: 400;
}
.report-digits-flex {
  margin-right: 8px;
  margin-left: 20px;
}
.additional-fiels {
  margin-top: 30px;
  width: 40vw;
}
.additional-fiels-mobile {
  margin: 1rem;
  margin-top: 30px;
}
.additional-fiels-title {
  margin-bottom: 5px;
  font-weight: bold;
}
</style>
